module.exports = __webpack_public_path__ + "static/media/wall_start.25b7e840.jpg";